import React, { Component } from 'react';
import { FormattedMessage } from "react-intl";
import Integrations from "../integration/Integrations.jsx";
import Status3DSecure from '../payment-processing/configuration-3ds/Status3DSecureBadge';
import { ExternalPaymentTypesMapping } from "../payment/externalpaymenttypesmapping.jsx";
import PaymentStatus from "./status.component.jsx";

class PaymentExternalDetails extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            payment: this.props.value || '',
            className: this.props.className || '',
            hideCta: this.props.hideCta || false,
        }
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            payment: nextProps.value || '',
            className: nextProps.className || '',
        })
    }

    componentDidMount() { }



    render() {
        if (!this.state.payment) {
            return <div />
        }
        const integratedPayment = this.state.payment.attributes.integratedPayment
        if (!integratedPayment) {
            return <div />
        }
        if (!integratedPayment.attributes.creditCardDetails && !integratedPayment.attributes.bankAccountDetails &&
            !integratedPayment.attributes.externalCheckoutDetails) {
            return <div />
        }
        const paymentMethod = []
        let label = ''
        const details = []
        if (integratedPayment.attributes.creditCardDetails) {
            const creditCardDetails = integratedPayment.attributes.creditCardDetails
            if (creditCardDetails.attributes.last4) {
                paymentMethod.push(creditCardDetails.attributes.brand.toUpperCase())
                paymentMethod.push(creditCardDetails.attributes.cardHolderName)
                label = <FormattedMessage
                    id="invoice.analytics.events.payment_received_exported.stripe.credit_card"
                    defaultMessage="Credit card"
                />
                details.push(<span>**** **** **** {creditCardDetails.attributes.last4}</span>)
                details.push(<span>
                    {creditCardDetails.attributes.expirationMonth}
                    &nbsp;/&nbsp;
                    {creditCardDetails.attributes.expirationYear}
                </span>)
                details.push(<PaymentStatus value={this.state.payment.attributes.status} />)
            }
        }
        if (integratedPayment.attributes.bankAccountDetails) {
            const bankAccountDetails = integratedPayment.attributes.bankAccountDetails
            paymentMethod.push(bankAccountDetails.attributes.bankName.toUpperCase())
            paymentMethod.push(bankAccountDetails.attributes.accountHolderName)
            label = <FormattedMessage
                id="invoice.analytics.events.payment_received_exported.stripe.bank_account"
                defaultMessage="Bank Account"
            />
            details.push(<span>******** {bankAccountDetails.attributes.last4}</span>)
            details.push(<PaymentStatus value={this.state.payment.attributes.status} />)
        }

        if (!integratedPayment.attributes.creditCardDetails && integratedPayment.attributes.externalCheckoutDetails) {
            label = <FormattedMessage
                id="invoice.analytics.events.payment_received_exported.external_checkout"
                defaultMessage="External checkout"
            />
            const paymentType = this.state.payment.attributes.type
            if (paymentType !== 'credit-card') {
                details.push(<pre>{ExternalPaymentTypesMapping[this.state.payment.attributes.type]}</pre>)
            }
            details.push(<PaymentStatus value={this.state.payment.attributes.status} />)
        }

        const externalLink = this.state.payment.attributes.externalLink
        const link = Integrations.getIntegratedPaymentTransactionExternalUrl(externalLink)
        const logo = Integrations.getPaymentExportedLogoImg(externalLink)
        const cta = Integrations.getPaymentExportedCtaFormattedMessage(externalLink)
        const data3DSecure = integratedPayment.attributes.data3DSecure

        return <div className={'w-100 d-flex align-items-start flex-wrap'}>
            <div className={'mr-3'}>
                <a href={link} target="_blank">
                    {logo}
                </a>
            </div>
            {paymentMethod.length > 0 &&
                <div className={'px-3'}>
                    <p className={'mb-1 border-bottom'}>
                        <small>
                            <FormattedMessage
                                id="invoice.analytics.events.payment_received_exported.stripe.payment_method"
                                defaultMessage="Payment method"
                            />
                        </small>
                    </p>
                    {paymentMethod.map((item, key) => {
                        return <pre className={'mb-0'} key={key}>
                            {item}
                        </pre>
                    })}
                </div>
            }
            <div className={'px-3'}>
                <p className={'mb-1 border-bottom'}>
                    <small>
                        {label}
                    </small>
                </p>
                {details.map((item, key) => {
                    return <pre className={'mb-0'} key={key}>
                        {item}
                    </pre>
                })}
            </div>
            {data3DSecure?.attributes?.status &&
                <div className={'px-3'}>
                    <p className={'mb-1 border-bottom'}>
                        <small>
                            <FormattedMessage
                                id="payment.analytics.3ds_secure_label"
                                defaultMessage="3D Secure"
                            />
                        </small>
                    </p>
                    <pre className={'mb-1'} key={"status-3ds"}>
                        <Status3DSecure status={data3DSecure.attributes.status} />
                    </pre>
                    {data3DSecure.attributes.failedReasonDescription &&
                        <pre className={'mb-0'} key={"failed-reason-description-3ds"}>
                            <p>{data3DSecure.attributes.failedReasonDescription}</p>
                        </pre>
                    }
                </div>
            }

            {
                !this.state.hideCta && cta && link &&
                <div >
                    <p className={'mb-0'}>
                        <a href={link} target={'_blank'} className={'btn btn-sm btn-outline-primary'}>
                            {cta}
                        </a>
                    </p>
                </div>
            }
        </div>
    }

}

export default PaymentExternalDetails





// WEBPACK FOOTER //
// ./src/payment/externaldetails.component.jsx